import { getUrl, getUrlByDomain } from '@js/common/getUrlByDomain'

import { errorLogger } from '@f-fertighaus/utils/errorLogger'

export const saveDataToLocalStorage = (steps, key = 'quiz') => {
  try {
    localStorage.setItem(
      key,
      JSON.stringify(
        steps.reduce((acc, currentStep) => {
          currentStep.values.map(value => {
            if (value.value) {
              acc[value.name] = value.value
            }
          })

          return acc
        }, {})
      )
    )
  } catch (e) {
    errorLogger(e)
  }
}

export const redirectToFinancePRQ = ({ steps, flow_type, flow_id }) => {
  /*
    Save the current data into localStorage to be read on the next Quiz
  */
  saveDataToLocalStorage(steps)
  const isIMCheckout =
    window.__DOMAIN__ === 'immowelt' ||
    window.__DOMAIN__ === 'immonet' ||
    window.__DOMAIN__ === 'bauen'

  if (isIMCheckout) {
    window.location = `${getUrl('financeQuiz')()}#fk=${flow_type}&fi=${flow_id}`
    return
  }

  window.location = `/finanzierungsberatung/#fk=${flow_type}&fi=${flow_id}`
}

export const redirectToDashboard = () => {
  window.location = `${getUrlByDomain(window.__DOMAIN__)(
    'userAccount'
  )()}uebersicht/`
}

export const redirectToSuccessPage = successRedirectPageUrl => {
  window.location = successRedirectPageUrl
}
